export default ({
  streetAddr1,
  street1,
  streetAddr2,
  street2,
  streetAddr3,
  street3,
  city,
  state, // can be string or object
  stateCode,
  isoCountry,
  zip5, // zip v1
  postalCode, // zip v2
  internationalPostalCode,
  province,
  countryCode,
  country,
  styles = {},
}) => {
  const stateAbbr = typeof state === 'string' ? state : null
  const { code: sCode } = state || {}
  const { code: cCode, description: cDescription } = isoCountry || {}
  const isInternational =
    (cCode && cCode !== 'US') ||
    (countryCode && countryCode !== 'US') ||
    (country && country !== 'United States' && country !== 'US')
  const stateOrProvince = stateAbbr || sCode || stateCode || province
  const titleCaseStyle = { textTransform: 'capitalize' }

  return (
    <address style={styles}>
      {streetAddr1 ? (
        <div className="addr-streetAddr1" style={titleCaseStyle}>
          {streetAddr1?.toLowerCase()}
        </div>
      ) : null}
      {streetAddr2 ? (
        <div className="addr-streetAddr2" style={titleCaseStyle}>
          {streetAddr2?.toLowerCase()}
        </div>
      ) : null}
      {streetAddr3 ? (
        <div className="addr-streetAddr3" style={titleCaseStyle}>
          {streetAddr3?.toLowerCase()}
        </div>
      ) : null}
      {street1 ? (
        <div className="addr-street1" style={titleCaseStyle}>
          {street1?.toLowerCase()}
        </div>
      ) : null}
      {street2 ? (
        <div className="addr-street2" style={titleCaseStyle}>
          {street2?.toLowerCase()}
        </div>
      ) : null}
      {street3 ? (
        <div className="addr-street3" style={titleCaseStyle}>
          {street3?.toLowerCase()}
        </div>
      ) : null}
      <div className="addr-city-state-zip">
        <span className="addr-city" style={titleCaseStyle}>
          {city?.toLowerCase()}
        </span>
        {city && stateOrProvince ? ', ' : null}{' '}
        {stateOrProvince && <span className="addr-state-province">{stateOrProvince}</span>}{' '}
        {(zip5 || postalCode || internationalPostalCode) && (
          <span className="addr-zip-postalcode">
            {zip5 || postalCode || internationalPostalCode}
          </span>
        )}
      </div>
      {isInternational ? (
        <div className="addr-country" style={titleCaseStyle}>
          {cDescription?.toLowerCase() || countryCode?.toLowerCase() || country?.toLowerCase()}
        </div>
      ) : null}
    </address>
  )
}
